import { dspConfig } from "./dsp.js";
export const POP_GUARD_MIN_TRANSIENT = 0.5;
export const POP_GUARD_MIN_ENERGY = 0.3;
export const POP_MIN_TRANSIENT = 0.3;
export const POP_MIN_ENERGY = 0.2;
export const POP_REFRACTORY_MS = 200;
export class PopOnsetGate {
    constructor() {
        Object.defineProperty(this, "lastFireAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -Infinity
        });
        Object.defineProperty(this, "fireCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
    }
    get count() {
        return this.fireCount;
    }
    reset() {
        this.lastFireAt = -Infinity;
        this.fireCount = 0;
    }
    accept(energy, transient, nowMs) {
        if (transient < POP_MIN_TRANSIENT || energy < POP_MIN_ENERGY) {
            return null;
        }
        const sinceLast = nowMs - this.lastFireAt;
        if (sinceLast < POP_REFRACTORY_MS)
            return null;
        this.lastFireAt = nowMs;
        this.fireCount += 1;
        return sinceLast;
    }
}
const TRANSIENT_OVERRIDE_TRANSIENT = 0.15;
const TRANSIENT_OVERRIDE_ENERGY = 0.3;
const REJECT = {
    clusterId: null,
    confidence: 0,
    delta: { precision: 0, consistency: 0 },
};
export function gateAndClassify(f, classifier) {
    const transientOverride = (f.transient ?? 0) >= TRANSIENT_OVERRIDE_TRANSIENT &&
        (f.energy ?? 0) >= TRANSIENT_OVERRIDE_ENERGY;
    if ((f.energy ?? 0) < dspConfig.energyGate && !transientOverride) {
        return REJECT;
    }
    const { label, confidence } = classifier.classify(f);
    if (!label || label === "silence") {
        return REJECT;
    }
    // NOTE: We intentionally do NOT apply an additional pop transient/energy
    // guard here. The classifier already produces the raw per-frame label and
    // confidence; re-gating pops with hand-tuned thresholds discards genuine
    // raw classifier feedback. Pop-specific onset debouncing (refractory
    // period) is handled separately by PopOnsetGate at the call sites, which
    // is about onset timing, not about suppressing the classifier signal.
    return {
        clusterId: label,
        confidence,
        delta: { precision: confidence, consistency: 0 },
    };
}
